import { changeLabelsFilter } from 'actions/profileLabels'
import { connect } from 'react-redux'

function mapStateToProps(state, props) {
    const { filters, isFetching, result, counts } = state.profileLabels
    const filter = filters[props.filterId]
    const filterResult = filter && result[filter.searchKey]
    const count = filter && counts[filter.searchKey]
    const countOnPage = filter && filterResult[filter.page || 0].length

    return {
        filter,
        count,
        countOnPage,
        isFetching,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        changeFilter: (id, options) => dispatch(changeLabelsFilter(id, options)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
